// extracted by mini-css-extract-plugin
export var circle = "_8v-1";
export var exitConfirmationModal = "_8v-5";
export var iframe = "_8v-0";
export var offline = "_8v-3";
export var online = "_8v-2";
export var workstationSelectError = "_8v-4";